import React, { memo } from 'react'
import { FormModal } from 'transfix-ui/components/Modals'
import { Spinner } from 'transfix-ui/components/Spinner'
import {
  useBulkDeleteRates,
  useDeleteRate,
} from 'apps/marketplace/apiTypes/requestForProposalLaneCarrierRates'
import { IRFPLaneRate } from 'apps/marketplace/utils/api/rfpLaneRates'

interface IDeleteRateConfirmationModalProps {
  rfpLaneRate?: IRFPLaneRate | null
  rfpLaneRates: IRFPLaneRate[]
  closeAction: (type?: string) => void
}

export const DeleteRateConfirmationModal = memo<IDeleteRateConfirmationModalProps>(
  ({ rfpLaneRate, rfpLaneRates = [], closeAction }) => {
    const { error: singleError, loading: singleLoading, mutate: singleDelete } = useDeleteRate({})
    const { error: bulkError, loading: bulkLoading, mutate: batchDelete } = useBulkDeleteRates({})
    const errorMessage = singleError?.message || bulkError?.message
    const requestLoading = singleLoading || bulkLoading

    const confirmDelete = () => {
      if (rfpLaneRate) {
        singleDelete(Number(rfpLaneRate.id)).then(() => {
          closeAction('delete-success')
        })
      } else if (rfpLaneRates.length > 0) {
        batchDelete({ ids: rfpLaneRates.map(rate => Number(rate.id)) }).then(() => {
          closeAction('bulk-delete-success')
        })
      }
    }

    return (
      <FormModal
        size={4}
        onClose={closeAction}
        open
        error={errorMessage}
        title=''
        className='ph0'
        actions={[
          {
            type: 'dismiss',
            label: 'Cancel',
            dataTest: 'cancel-rate-button',
            action: closeAction,
            disabled: requestLoading,
          },
          {
            label: 'Delete',
            type: 'confirm',
            dataTest: 'delete-confirm-button',
            action: confirmDelete,
            disabled: requestLoading,
          },
        ]}>
        <span>
          Are you sure that you want to delete{' '}
          {rfpLaneRate ? 'this sourced rate' : 'these sourced rates'}?
        </span>
        {requestLoading && (
          <div className='mv3'>
            <Spinner position='relative' />
          </div>
        )}
      </FormModal>
    )
  }
)
